import React from 'react'
import ContactorPage from './ContactorPage';

function Index(
    {
        expanded
    }) {
    return expanded && <ContactorPage />
}

export default Index;